import { EmailLogin } from '../../widgets/Login/components/EmailLogin/EmailLogin'
import { useLoginLogic } from '../../widgets/Login/hooks/useLoginLogic'
import styles from './styles/LoginPage.module.scss'
import { PhoneVerificationForm } from '../../widgets/Login/components/PhoneVerificationForm/PhoneVerificationForm'
import { SsoLogin } from '../../widgets/Login/components/SsoLogin/SsoLogin'
import { EmailReset } from '../../widgets/Login/components/EmailReset/EmailReset'
import dashboardScreen from 'assets/img/screens/dashboard.png'
import studentsScreen from 'assets/img/screens/students.png'
import logoImg from 'assets/kandor_logo.png'

export const LoginPage = () => {
	const {
		activeTab,
		setActiveTab,
		loading,
		authAction,
		error,
		handleGoogleLogin,
		emailStep,
		emailCode,
		setEmailCode,
		handleEmailPasswordAuth,
		handleEmailCodeVerify,
		resetEmailFlow,
		isVisiblePassword,
		setIsVisiblePassword,
		email,
		setEmail,
		emailValid,
		googleExplanation,
		password,
		setPassword,
		handleMicrosoft,
		handelForgotPassword,
		handleResetRequest,
		resetPasswordFlow,
		setResetCode,
		resetCode,
		handleResetVerifyCode,
	} = useLoginLogic()

	return (
		<div className={styles.login}>
			{/* Left side */}
			<div className={styles.left}>
				<div className={styles.header}>
					<div className={styles.logo}>
						<img src={logoImg} alt="Kandor" />
					</div>
					<span className={styles.brand}>Counseling</span>
				</div>

				<div className={styles.content}>
					<div className={styles.content__inner}>
						<h1 className={styles.left__title}>
							All your student workflows in one place
						</h1>

						<p className={styles.description}>
							Manage students, tasks and applications with clarity
						</p>
					</div>

					<div className={styles.visual}>
						<img
							src={dashboardScreen}
							alt="Dashboard preview"
							className={styles.mainImage}
						/>

						<img
							src={studentsScreen}
							alt="Students preview"
							className={styles.overlayImage}
						/>
					</div>
				</div>
			</div>

			{/* Right side */}
			<div className={styles.right}>
				<div className={styles.head}>
					<h2 className={styles.title}>Sign In</h2>
					<span className={styles.head__info}>
						Welcome back! Please enter your details.
					</span>
				</div>

				<div className={styles.tabs}>
					{['email', 'sso'].map(tab => (
						<button
							key={tab}
							type="button"
							disabled={loading}
							onClick={() => {
								setActiveTab(tab)
							}}
							className={`${styles.tabBtn} ${activeTab === tab ? styles.active : ''}`}
						>
							{tab === 'email' ? 'Email Login' : 'Single Sign On'}
						</button>
					))}
				</div>

				{error && <div className={styles.error}>{error}</div>}

				{activeTab === 'email' && (
					<>
						{emailStep === 'form' ? (
							<EmailLogin
								loading={loading}
								authAction={authAction}
								onLogin={handleEmailPasswordAuth}
								email={email}
								setEmail={setEmail}
								emailValid={emailValid}
								password={password}
								setPassword={setPassword}
								isVisiblePassword={isVisiblePassword}
								setIsVisiblePassword={setIsVisiblePassword}
								onGoogleLogin={handleGoogleLogin}
								googleExplanation={googleExplanation}
								onForgotPassword={handelForgotPassword}
							/>
						) : emailStep === 'resetPassword' ? (
							<EmailReset
								loading={loading}
								email={email}
								setEmail={setEmail}
								handleResetRequest={handleResetRequest}
								resetPasswordFlow={resetPasswordFlow}
							/>
						) : (
							<PhoneVerificationForm
								loading={loading}
								verificationCode={
									emailStep === 'verifyCodeReset' ? resetCode : emailCode
								}
								setVerificationCode={
									emailStep === 'verifyCodeReset'
										? setResetCode
										: setEmailCode
								}
								phoneNumber={email}
								onVerifyCode={
									emailStep === 'verifyCodeReset'
										? handleResetVerifyCode
										: handleEmailCodeVerify
								}
								onReset={
									emailStep === 'verifyCodeReset'
										? resetPasswordFlow
										: resetEmailFlow
								}
							/>
						)}
					</>
				)}

				{activeTab === 'sso' && (
					<SsoLogin
						handleSSOLogin={handleMicrosoft}
						loading={loading}
						authAction={authAction}
					/>
				)}

				<div id="clerk-captcha" />

				<div className={styles.terms}>
					By signing in, you agree to our Terms of Service and Privacy Policy
				</div>
			</div>
		</div>
	)
}
